// 获取APP信息
export function cppGetAppInfo() {
    try {
        return window.cppGetAppInfo()
    } catch (e) {}
}

// 设置窗口标题
export function setWindowTitle(title) {
    try {
        window.cppSetWindowTitle(title)
    } catch (error) {}
}

// 设置窗口图标
export function cppSetWindowIcon(file_name) {
    try {
        window.cppSetWindowIcon(file_name)
    } catch (e) {}
}

// 设置当前窗口为主窗口
export function cppSetToMainWindow() {
    try {
        window.cppSetToMainWindow()
    } catch (e) {}
}

export function cppMouseDown(e) {
    try {
        window.cppMouseDown(e.clientX, e.clientY)
    } catch (error) {}
}

export function cppMouseMove(e) {
    try {
        window.cppMouseMove(e.clientX, e.clientY)
    } catch (error) {}
}

export function cppMouseUp(e) {
    try {
        window.cppMouseUp(e.clientX, e.clientY)
    } catch (error) {}
}


// 打开新页面
export function cppOpenWindow(url, x, y) {
    try {
        window.cppOpenWindow(url, x, y)
    } catch (e) {}
}

// 获取窗口位置
export function cppGetWindowPos() {
    try {
        return window.cppGetWindowPos()
    } catch (e) {}
}

// 获取屏幕分辨率
export function cppScreenSize() {
    try {
        return window.cppScreenSize()
    } catch (e) {}
}


// 关闭当前窗口
export function cppCloseWindow() {
    try {
        window.cppCloseWindow()
    } catch (e) {}
}

// 最小化窗口
export function cppWindowsMinisize() {
    try {
        window.cppWindowsMinisize()
    } catch (e) {}
}

// 用默认浏览器打开页面
export function cppOpenUrlUseDefaultBrowser(url_addr) {
    try {
        window.cppOpenUrlUseDefaultBrowser(url_addr)
    } catch (e) {}
}

// 置顶窗口
export function cppWindowsAlawsOnTop(b) {
    try {
        window.cppWindowsAlawsOnTop(b)
    } catch (e) {}
}

// 退出程序
export function cppQuitApp() {
    try {
        window.cppQuitApp()
    } catch (e) {}
}

// 设置播放器屏蔽关键词
export function cppUpdatePlayerMaskKeywords(recvdata) {
    var str = JSON.stringify(recvdata)
    try {
        window.cppUpdatePlayerMaskKeywords(str)
    } catch (e) {}
}

// 开始监听播放器
export function cppStartPlayerMonitor() {
    try {
        window.cppStartPlayerMonitor()
    } catch (e) {}
}

export function cppUpdatePluginFilter(recvdata) {
    const str = JSON.stringify(recvdata)
    try {
        window.cppUpdatePluginFilter(str)
    } catch (e) {}
}

export function cppUpdateSupportPlugins(recvdata) {
    const str = JSON.stringify(recvdata)
    try {
        window.cppUpdateSupportPlugins(str)
    } catch (e) {}
}

// 设置基调
export function cppUpdateKeynote(keynote) {
    try {
        window.cppUpdateKeynote(keynote)
    } catch (e) {}
}

// 设置速率
export function cppUpdateSpeed(v) {
    try {
        window.cppUpdateSpeed(v)
    } catch (e) {}
}

// 设置升降调
export function cppUpdateTune(v) {
    try {
        window.cppUpdateTune(v)
    } catch (e) {}
}

// 写base64文件
export function cppWriteBase64File(file_name, data) {
    try {
        return window.cppWriteBase64File(file_name, data)
    } catch (e) {}
}

// 获取插件信息
export function cppGetRemoteStatus() {
    try {
        window.cppGetRemoteStatus()
    } catch (e) {}
}

// 广播消息
export function cppBroadcastWndMsg(msg) {
    try {
        window.cppBroadcastWndMsg(msg)
    } catch (e) {}
}

// v3.2.0新增
// 重置窗口尺寸
export function cppAdaptWindowSize() {
    try {
        window.cppAdaptWindowSize()
    } catch (e) {}
}
// 设置窗口大小
export function cppSetWindowSize(width, height) {
    try {
        window.cppSetWindowSize(width, height)
    } catch (e) {}
}

// 设置电音输入类型
export function cppUpdateInputType(tp) {
    try {
        window.cppUpdateInputType(tp)
    } catch (e) {}
}

// 检测是否开启自启
export function cppCheckAppAutoRun() {
    try {
        return window.cppCheckAppAutoRun()
    } catch (e) {}
}

// 开机自启
export function cppSetAppAutoRun(b) {
    try {
        window.cppSetAppAutoRun(b)
    } catch (e) {}
}

// 本地数据库相关

// 打开一个数据库
// db string 数据库路径，默认当前路径
//返回值:成功 true  失败false
export function cppDbOpen(db) {
    try {
        return window.cppDbOpen(db)
    } catch (e) {}
}

// 关闭当前数据库
//返回值:无
export function cppDbClose() {
    try {
        return window.cppDbClose()
    } catch (e) {}
}

// 当前数据库是否存在数据表
// tablename string 数据表的名称
// 返回值:存在 true  不存在 false
export function cppDbTableExist(tablename) {
    try {
        return window.cppDbTableExist(tablename)
    } catch (e) {}
}

// 当前数据库执行sql操作，查询不适用。通常是对数据库进行修改操作
// sq string sql语句
//返回值:int 错误码 0成功
export function cppDbExecSql(sq) {
    try {
        return window.cppDbExecSql(sq)
    } catch (e) {}
}

// 当前数据库执行sql操作，查询使用
// sq string sql语句
//返回值:对象数组  （数据查询行的数组）
//每一行对应一个数据列数组
// 列对象自带类型，根据创建的数据库类型对应
export function cppDbExecQuerySql(sq) {
    try {
        return window.cppDbExecQuerySql(sq)
    } catch (e) {}
}

// 获取当前路径
export function cppGetCurrentDir() {
    try {
        return window.cppGetCurrentDir()
    } catch (e) {}
}

// 使用文件浏览器打开路径
// path string 路径
// 返回值 无
export function cppExploreFolder(folder) {
    try {
        window.cppExploreFolder(folder)
    } catch (error) {}
}

// 开始运行异步运行后台远程插件识别循环
export function cppRunAsyncPluginIdentify() {
    try {
        window.cppRunAsyncPluginIdentify()
    } catch (error) {}
}

// 设置vst3运行模式是否远程执行
// sq bool remote true远程执行，false只启用文本修改模式
export function cppSetVst3AutoRemote(remote) {
    try {
        window.cppSetVst3AutoRemote(remote)
    } catch (error) {}
}

// 3.7.0新增 通用接口 通过cmd控制不同类型
// 设置电音弹性
export function cppUpdateFlex(flexValue) {
    const msg = {
        cmd: "cmd_flex_tune",
        data: {
            flexValue: parseInt(flexValue)
        }
    }
    try {
        window.cppCommRemoteTuneMsg(JSON.stringify(msg))
    } catch (error) {}
}


// 设置电音拟人
export function cppUpdateHumanize(humanizeValue) {
    const msg = {
        cmd: "cmd_humanize_tune",
        data: {
            humanizeValue: parseInt(humanizeValue)
        }
    }
    try {
        window.cppCommRemoteTuneMsg(JSON.stringify(msg))
    } catch (error) {}
}

// 3.8.0修改
// 获取升级调插件路径
export function cppAutoTunePluginPath(name) {
    try {
        return window.cppAutoTunePluginPath(name)
    } catch (e) {}
}
// 检测酷狗是否安装了插件
export function cppCheckInstallAutoTunePlugin(name) {
    try {
        return window.cppCheckInstallAutoTunePlugin(name)
    } catch (e) {}
}
// 酷狗安装插件 enable_bridge是否使用桥接
export function cppInstallAutoTunePlugin(name, enable_bridge = false) {
    try {
        window.cppInstallAutoTunePlugin(name, enable_bridge)
    } catch (e) {}
}
// 酷狗卸载插件
export function cppUnInstallAutoTunePlugin(name) {
    try {
        window.cppUnInstallAutoTunePlugin(name)
    } catch (e) {}
}
// 3.9.0 QQ音乐和酷我安装卸载插件
// 安装QQ音乐插件，plugin_name查看player.json配置
export function cppInstallQQMusicAutoTunePlugin(plugin_name) {
    try {
        window.cppInstallQQMusicAutoTunePlugin(plugin_name);
    } catch (error) {}
}
// 取消QQ音乐插件，plugin_name查看player.json配置
export function cppUnInstallQQMusicAutoTunePlugin(plugin_name) {
    try {
        window.cppUnInstallQQMusicAutoTunePlugin(plugin_name);
    } catch (error) {}
}
// 获取QQ音乐插件的路径，plugin_name查看player.json配置
export function cppQQMusicAutoTunePluginPath(plugin_name) {
    try {
        return window.cppQQMusicAutoTunePluginPath(plugin_name);
    } catch (error) {}
}
// 获取QQ音乐插件是否已经安装
export function cppCheckQQMusicInstallAutoTunePlugin(plugin_name) {
    try {
        return window.cppCheckQQMusicInstallAutoTunePlugin(plugin_name);
    } catch (error) {}
}

// 安装酷我插件，plugin_name查看player.json配置
export function cppInstallKwMusicPlugin(plugin_name) {
    try {
        window.cppInstallKwMusicPlugin(plugin_name);
    } catch (error) {}
}
// 取消酷我插件，plugin_name查看player.json配置
export function cppUnInstallKwMusicPlugin(plugin_name) {
    try {
        window.cppUnInstallKwMusicPlugin(plugin_name);
    } catch (error) {}
}
// 获取酷我插件的路径，plugin_name查看player.json配置
export function cppKwMusicPluginPath(plugin_name) {
    try {
        return window.cppKwMusicPluginPath(plugin_name);
    } catch (error) {}
}
// 获取酷我插件是否已经安装
export function cppKwMusicCheckInstallAutoTunePlugin(plugin_name) {
    try {
        return window.cppKwMusicCheckInstallAutoTunePlugin(plugin_name);
    } catch (error) {}
}

// 3.8.0新增
// 设置全民K歌升降调
export function cppUpdateWesingTune(tone) {
    try {
        window.cppUpdateWesingTune(tone);
    } catch (error) {}
}
// // 播放器升降调通知
// // tone 当前调，player 播放器名称
// onPlayerToneChange(tone,player)

export function cppSendRemoteMessage(data) {
    try {
        console.log(data.cmd);
        const dataStr = JSON.stringify(data);
        window.cppSendRemoteMessage(dataStr, data.cmd);
    } catch (error) {}
}

export function cppSendRemoteMessageKeynote(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_KEYNOTE",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageTune(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_TUNE",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageSpeed(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_SPEED",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageHumanize(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_HUMANIZE",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageFlex(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_FLEX",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageVibrato(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_VIBRATO",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageTracking(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_TRACKING",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageEmValue(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_EMVALUE",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageInputType(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_INPUTTYPE",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageVocals(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_VOCALS",
        serialNum: serialNum,
        params: params,
    })
}
export function cppSendRemoteMessageMultiple(params, serialNum) {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_MULTIPLE",
        serialNum: serialNum,
        params: params,
    })
}

// v3.9.0
// 获取扬声器设备列表
export function cppGetAudioDeviceList() {
    try {
        return window.cppGetAudioDeviceList()
    } catch (error) {}
}
// 采集音频流信息通过指定扬声器设备
export function cppStartRecordDevice(device_name) {
    try {
        return window.cppStartRecordDevice(device_name)
    } catch (error) {}
}
// 采集音频流信息通过指定进程名称
export function cppStartRecordDeviceByProcessName(process_name) {
    try {
        return window.cppStartRecordDeviceByProcessName(process_name)
    } catch (error) {}
}
// 重置音频分析模块
export function cppResetEmusicKeynote() {
    try {
        return window.cppResetEmusicKeynote()
    } catch (error) {}
}
// 设置音频分析模块系列参数，传入json字符串
export function cppSetEmusicKeynoteParams(params) {
    try {
        params = JSON.stringify(params)
        return window.cppSetEmusicKeynoteParams(params)
    } catch (error) {}
}

// 已经新增 暂未使用 文件读写功能
// cppWriteStringFile
// cppWriteFile
// cppReadFile
// cppReadStringFile
// cppProcessExist
// cppKillProcess
// cppValidFileExist
// cppValidPathExist

// v3.9.2
// 启动关闭音频频谱
export function cppEnableAudioFFT(enable) {
    try {
        window.cppEnableAudioFFT(enable)
    } catch (error) {}
}
// 禁用插件组件释放
export function cppSendRemoteMessageDisableFree() {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_DISABLE_FREE_COMPONENT"
    })
}
// 启用插件组件释放
export function cppSendRemoteMessageEnableFree() {
    cppSendRemoteMessage({
        cmd: "REMOTE_MSG_ENABLE_FREE_COMPONENT"
    })
}

// 清楚电音参数缓存
export function cppRemoteClearParamsCache() {
    cppSendRemoteMessage({
        cmd: "REMOTE_CLEAR_PARAMS_CACHE"
    });
}

// 文件读写
export function cppReadStringFile(filepath) {
    try {
        return window.cppReadStringFile(filepath)
    } catch (e) {}
}
export function cppWriteStringFile(filepath, string, mode = "w+") {
    try {
        return window.cppWriteStringFile(filepath, string, mode)
    } catch (e) {}
}
// 检查文件是否存在
export function cppValidFileExist(path) {
    try {
        return window.cppValidFileExist(path)
    } catch (e) {}
}

// 临时使用一个废弃的接口来线上修复新版酷狗v20061加不了插件的问题
export function cppFixKugou() {
    const msg = {
        cmd: "cmd_fix_kugo",
    }
    try {
        window.cppCommRemoteTuneMsg(JSON.stringify(msg))
    } catch (error) {}
}

// 3.9.7内核版本新增 

// 从云端下载lua脚本并且执行
// 示例如下，依次下载depends列表内依赖的脚步 然后执行entry的脚本
// userData为自定义数据 可以为字符串或者对象 传入之后 在onRunWebToolFunctionCallback通知的时候原样返回
// const data = {
//     "entry": ".\\script\\webtool.lua",
//     "depends": [
//         {
//             "url": "https://yuneffect.com/emusic3web/webtool.lua",
//             "savePath": ".\\script\\webtool.lua"
//         },
//     ]
// }
export function cppRunWebToolFunctionLoadScript(data, userData) {
    const msg = {
        cmd: "cmd_load_script",
        data: data,
        userData: userData
    }
    try {
        window.cppRunWebToolFunction(JSON.stringify(msg))
    } catch (e) {}
}

// 执行指定脚本中的函数
// 示例如下, entry指定要执行的函数所在的脚步，functionName是函数名称，param为函数需要的参数
// userData为自定义数据 可以为字符串或者对象 传入之后 在onRunWebToolFunctionCallback通知的时候原样返回
// const data = {
//     "entry": ".\\script\\webtool.lua",
//     "functionName":"GetSystemEnv",
//     "param":{
//         "env":"APPDATA"
//     }
// }
export function cppRunWebToolFunctionCallScrtptFun(data, userData) {
    const msg = {
        cmd: "cmd_call_script_function",
        data: data,
        userData: userData
    }
    try {
        window.cppRunWebToolFunction(JSON.stringify(msg))
    } catch (e) {}
}
//脚本执行结果在事件 onRunWebToolFunctionCallback 内通知

// 获取酷狗效果是否开启
export function cppGetKugouAudioEffectStatus() {
    try {
        return window.cppGetKugouAudioEffectStatus()
    } catch (e) {}
}
// 开启或者关闭酷狗效果
export function cppSetKugouAudioEffectStatus(enable) {
    try {
        window.cppSetKugouAudioEffectStatus(enable)
    } catch (e) {}
}

// 3.9.9新增
export function cppShellExecuteEx(params) {
    params = JSON.stringify(params)
    try {
        return window.cppShellExecuteEx(params)
    } catch (e) {}
}
// 更新屏蔽进程列表
export function cppUpdateMaskProcessList(processAry) {
    const params = JSON.stringify(processAry)
    try {
        return window.cppUpdateMaskProcessList(params)
    } catch (e) {}
}
// 获取环境变量 name 环境变量名称 例如："APPDATA" "PATH"等
export function cppGetEnvVar(name) {
    try {
        return window.cppGetEnvVar(name)
    } catch (e) {}
}
// 读取ini文件
export function cppIniReadValue(path, sectionName, key) {
    try {
        return window.cppIniReadValue(path, sectionName, key)
    } catch (e) {}
}
// 写入ini文件
export function cppIniWriteValue(path, sectionName, key, value) {
    try {
        return window.cppIniWriteValue(path, sectionName, key, value)
    } catch (e) {}
}
// 读取注册表
export function cppRegReadValue(rootKey, path, key) {
    try {
        return window.cppRegReadValue(rootKey, path, key)
    } catch (e) {}
}
// 写入注册表 暂时仅支持字符串写入 例如：cppRegWriteValue("HKCU", "SOFTWARE\\MyApp", "Setting", "hello");
export function cppRegWriteValue(rootKey, path, key, value) {
    try {
        return window.cppRegWriteValue(rootKey, path, key, value)
    } catch (e) {}
}
// 发送给伴奏助手的消息 关闭伴奏助手窗口
export function cppAccHelperWindowClose() {
    try {
        const data = JSON.stringify({
            msgType: "request",
            msgId: "ext-1",
            cmd: "WINDOW_CLOSE",
            data: {}
        })
        window.cppSendCopyDataMsg("伴奏助手", data)
    } catch (e) {}
}
// 发送给伴奏助手的消息 展示伴奏助手窗口
export function cppAccHelperWindowShow() {
    try {
        const data = JSON.stringify({
            msgType: "request",
            msgId: "ext-2",
            cmd: "WINDOW_SHOW",
            data: {}
        })
        window.cppSendCopyDataMsg("伴奏助手", data)
    } catch (e) {}
}
// 发送给伴奏助手的消息 设置窗口定位
export function cppAccHelperWindowSetPosition(pos) {
    try {
        const data = JSON.stringify({
            msgType: "request",
            msgId: "ext-3",
            cmd: "WINDOW_SET_POSITION",
            data: {x: pos.x, y: pos.y}
        })
        window.cppSendCopyDataMsg("伴奏助手", data)
    } catch (e) {}
}
// 检测进程是否存在
export function cppCheckProcessExist(processName) {
    try {
        return window.cppCheckProcessExist(processName)
    } catch (e) {}
}

// 获取设备信息列表
export function cppGetAudioDeviceInfoList() {
    try {
        return JSON.parse(window.cppGetAudioDeviceInfoList())
    } catch (e) {}
}
// 设置默认音频设备
export function cppSetDefaultAudioDevice(deviceId) {
    try {
        return window.cppSetDefaultAudioDevice(deviceId)
    } catch (e) {}
}
// 安装伴奏助手驱动
export function cppInstallRootDriver(hardwareId, infPath) {
    try {
        return JSON.parse(window.cppInstallRootDriver(hardwareId, infPath))
    } catch (e) {}
}
// 卸载伴奏助手驱动
export function cppRemoveRootDriver(hardwareId) {
    try {
        return JSON.parse(window.cppRemoveRootDriver(hardwareId))
    } catch (e) {}
}
// 设备重命名
export function cppRenameAudioDevice(deviceType, interfaceName, name) {
    try {
        return window.cppRenameAudioDevice(deviceType, interfaceName, name)
    } catch (e) {}
}
